export default __webpack_public_path__ + "static/f1-5e1d2ddb475370d93cdbc33da007bbf8.svg";